import { render, staticRenderFns } from "./InfolgtEditor.vue?vue&type=template&id=de127ea8"
import script from "./InfolgtEditor.vue?vue&type=script&lang=js"
export * from "./InfolgtEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports